export interface ChildColor {
  hex: string;
  label: string;
  group: 'female' | 'male' | 'neutral';
}

export const CHILD_COLORS: ChildColor[] = [
  // Girlish
  { hex: '#E8849A', label: 'Rose',       group: 'female'  },
  { hex: '#B89AC8', label: 'Lavender',   group: 'female'  },
  { hex: '#F0A882', label: 'Peach',      group: 'female'  },
  { hex: '#C47A92', label: 'Mauve',      group: 'female'  },
  // Boyish
  { hex: '#7AAEC8', label: 'Sky',        group: 'male'    },
  { hex: '#7A8EC0', label: 'Slate',      group: 'male'    },
  { hex: '#5CAAA4', label: 'Teal',       group: 'male'    },
  { hex: '#6A8EAC', label: 'Navy',       group: 'male'    },
  // Neutral
  { hex: '#F2A623', label: 'Amber',      group: 'neutral' },
  { hex: '#7A9A7C', label: 'Sage',       group: 'neutral' },
  { hex: '#C45B4B', label: 'Terracotta', group: 'neutral' },
  { hex: '#9A7AB0', label: 'Plum',       group: 'neutral' },
];

/**
 * Pick a color from the gender pool, preferring colors not already in use.
 * Falls back to hash-based pick if all pool colors are taken.
 */
export function autoAssignColor(
  gender: 'male' | 'female' | 'neutral',
  name = '',
  usedColors: string[] = [],
): string {
  const pool = CHILD_COLORS.filter((c) => c.group === gender);
  const unused = pool.filter((c) => !usedColors.includes(c.hex));
  const candidates = unused.length > 0 ? unused : pool;
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash += name.charCodeAt(i);
  return candidates[hash % candidates.length].hex;
}
